export default class Advertisement {
  id?: number;
  title: string;
  description: string;
  body: string;
  created_at?: string;
  updated_at?: string;

  constructor(values: AdvertisementConstructValue) {
    this.id = values.id;
    this.title = values.title;
    this.description = values.description;
    this.body = values.body;
    this.created_at = values.created_at;
    this.updated_at = values.updated_at;
  }
}

export interface AdvertisementConstructValue {
  id?: number;
  title: string;
  description: string;
  body: string;
  created_at?: string;
  updated_at?: string;
}


export interface SearchAdvertisementRequestParam {
  title?: string;
}